import type { SxProps } from '@mui/material';
import type { ImageProps } from 'next/image';
import Image from 'next/image';
import type { Ref } from 'react';
import { forwardRef, useState } from 'react';
import { Box } from '../Box';
import { akamaiLoader } from '../Image/loader';

export interface FadedImageProps extends ImageProps {
  /** MUI System props for image wrapper: https://mui.com/system/the-sx-prop/ */
  sx?: SxProps;
  /** Duration of fade in transition in miliseconds
   @default: 200
   */
  transitionDuration?: number;
  /** type of component */
  component?: 'div' | 'span';
  /** Ref for the image element */
  ref?: Ref<HTMLImageElement>; // Change the type of ref to HTMLImageElement
}

/** Animated wrapper component for next/image: https://nextjs.org/docs/api-reference/next/image */
export const FadedImage = forwardRef<HTMLImageElement, FadedImageProps>(
  ({ sx, transitionDuration = 200, component = 'div', ...props }, ref) => {
    const [loaded, setLoaded] = useState(false);

    return (
      <Box
        component={component}
        sx={{ opacity: loaded ? 1 : 0, transition: `opacity ${transitionDuration}ms`, ...sx }}
      >
        <Image
          {...props}
          onLoadingComplete={() => setLoaded(true)}
          {...(ref && { ref })}
          loader={akamaiLoader}
        />
      </Box>
    );
  },
);
